<div class="expander">
  <div class="simple-message">
    <div class="simple-message-text">
      <span>{{simpleMessage()}}</span>

      @if (simpleMessageInfo() !== null) {
        <span class="simple-message-info">{{simpleMessageInfo()}}</span>
      }
    </div>

    <button mat-raised-button class="tiny-button" color="secondary" (click)="toggleFullMessage()" title="Show Full Error">
      @if (expanded()) {
        <mat-icon>expand_less</mat-icon>
      } @else {
        <mat-icon>expand_more</mat-icon>
      }
    </button>

    <button mat-raised-button class="tiny-button" color="secondary" (click)="copyFullMessage()" title="Copy Full Error">
      <mat-icon>file_copy</mat-icon>
    </button>
  </div>

  @if (expanded()) {
    <div class="full-message-container">
      <mat-checkbox [(ngModel)]="textWrap">
        Word Wrap
      </mat-checkbox>

      <div class="full-message" [innerHTML]="formattedFullMessage()" [class.text-wrap]="textWrap()"></div>
    </div>
  }
</div>
